import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import getBrowserFingerprint from "get-browser-fingerprint";
import { browserName, isIOS } from "react-device-detect";
import loadericon from "../assets/img/Rollingnew.svg";
import { Base64 } from "js-base64";
import Multiselect from "multiselect-react-dropdown";

const Traineedetails = () => {
  const fingerprint = getBrowserFingerprint();
  const {
    register,
    // reset,
    formState: { errors },
    handleSubmit,
    clearErrors,
    setValue,
    // getValues,
  } = useForm({
    mode: "onSubmit",
  });
  const { t } = useTranslation(["certificationForm", "certificationView", "Footer"]);
  const history = useNavigate();
  const submitbutton = useRef();
  const [isloader, setIsloader] = useState(false);
  const [emailaddressrequired, setEmailaddressrequired] = useState(false);
  const [fullnamerequired, setFullnamerequired] = useState(false);
  
  useEffect(() => {
    const agencyEmail = localStorage.getItem("agencyEmail");
    if (agencyEmail) {
      setValue("emailPromoterAgency", agencyEmail);
    }
    // register fields that we update via setValue / control manually
    // make the multiselect required so react-hook-form knows it's mandatory
    register("brandMultiselectDropdown", { required: true });
    register("brandOther");
  }, [register, setValue]);

  const [btnDisable, setbtnDisable] = useState(true);
  const [submitted, setsubmitted] = useState(false);

  const [selectedBrands, setSelectedBrands] = useState([]);
  const [otherBrandValue, setOtherBrandValue] = useState("");

  const getCaertificateTag = (id, key) => {
    const jsondata = Object.values(
      t("certificateContent", { returnObjects: true, ns: "certificationView" })
    );
    const data = jsondata.find((item) => {
      return item.id === id && item.key !== "";
    });
    return data[key];
  };

  const getFooterTag = (id, key) => {
    const jsondata = Object.values(
      t("LeftFooter", { returnObjects: true, ns: "Footer" })
    );
    const data = jsondata.find((item) => {
      return item.id === id && item.key !== "";
    });
    return data[key];
  };

  const getdata = (id, field_type, key, segment) => {
    const jsondata = Object.values(t(segment, { returnObjects: true }));
    const data = jsondata.find((item) => {
      return item.id === id && item.fieldType === field_type && item.key !== "";
    });

    return data ? data[key] : "";
  };

  const isOtherOption = (val) => {
    if (!val) return false;
    return String(val).toLowerCase().trim().includes("other");
    // this will match "other", "others", "Other - please specify", etc.
  };

  const onSubmit = async (data) => {
    // Build brands payload (respecting "other")
    const brandsPayload = (selectedBrands || []).reduce((acc, brand) => {
      const v = String(brand.value || "").trim();
      if (isOtherOption(v)) {
        if (otherBrandValue && otherBrandValue.trim() !== "") {
          acc.push(otherBrandValue.trim());
        }
      } else {
        acc.push(v);
      }
      return acc;
    }, []);

    const eamilcheck = localStorage.getItem("lastEmailAddress");

    if (eamilcheck !== data["emailAddress"]) {
      const keepKeys = ["lanCode", "lanName", "lanId", "aGencyID", "aGencyCcod", "agencyEmail"];
      Object.keys(localStorage).forEach((k) => {
        if (!keepKeys.includes(k)) {
          localStorage.removeItem(k);
        }
      });
    }
    localStorage.setItem("lastEmailAddress", data["emailAddress"]);

    if (!submitted) {
      try {
        setbtnDisable(true);
        setIsloader(true);
        setsubmitted(true);
        localStorage.setItem("emailAddress", Base64.encode(data["emailAddress"]));

        const res = await axios.post(process.env.REACT_APP_API_ENDPOINT + "/submittraineedata", {
          fullName: data["fullName"],
          emailAddress: data["emailAddress"],
          emailPromoterAgency: data["emailPromoterAgency"],
          idPromoterAgency: localStorage.getItem("aGencyID"),
          uniqueCodeUsed: localStorage.getItem("aGencyCcod"),
          idlanguage: localStorage.getItem("lanId"),
          brands: brandsPayload,
          useremail: t("UserEmail", { returnObjects: true }),
          agencypromoteremail: t("AgencyPromoterEmail", {
            returnObjects: true,
          }),

          HeaderTag1: getCaertificateTag("h2_brandPromotor_tr_cert", "certificatetagTag1"),
          HeaderTag2: getCaertificateTag("h2_brandPromotor_tr_cert", "certificatetagTag2"),
          NameTag: getCaertificateTag("plain_text_NAME_CV", "value"),
          DateTag: getCaertificateTag("plain_text_DATE_CV", "value"),
          CertifiacteNoTag: getCaertificateTag("plain_text_CSN_CV", "value"),
          AgencyNameTag: getCaertificateTag("plain_text_BPA_CV", "value"),
          EmailFooterDes: getFooterTag("rich_text_footer_PH1", "value"),
        });
          let certificateDataFlag = res.data.flag || 'new';
          localStorage.setItem("certificateDataFlag", certificateDataFlag);
        if (res && res.data.status === 1) {
          const plain_text_BPA_CV_WithCity =
            res.data.values.promoteragency.AgencyCity !== ""
              ? res.data.values.promoteragency.PromoterAgencyName + ",\n" + res.data.values.promoteragency.AgencyCity
              : res.data.values.promoteragency.PromoterAgencyName;

          const plain_text_BPA_CV =
            res.data.values.promoteragency.AgencyLocation !== ""
              ? res.data.values.promoteragency.AgencyCity !== ""
                ? plain_text_BPA_CV_WithCity + ", " + res.data.values.promoteragency.AgencyLocation
                : plain_text_BPA_CV_WithCity + ",\n" + res.data.values.promoteragency.AgencyLocation
              : plain_text_BPA_CV_WithCity;

          localStorage.setItem("plain_text_NAME_CV", res.data.values.fullName);
          localStorage.setItem("plain_text_DATE_CV", Base64.encode(res.data.values.certificationDate));
          localStorage.setItem("plain_text_CSN_CV", Base64.encode(res.data.values.certificateNumber));
          localStorage.setItem("plain_text_BPA_CV", Base64.encode(plain_text_BPA_CV));

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "customEvent",
            eventCategory: "Button",
            eventAction: "Button/Page View",
            eventLabel: "GOAL",
            eventValue: "Successful",
          });
          localStorage.setItem("PID", Base64.encode(fingerprint + "P6"));
          history("/");
          window.location.reload();
        } else {
          // fallback handling (your existing logic)
          const payload = {
            fullName: data["fullName"],
            emailAddress: data["emailAddress"],
            emailPromoterAgency: data["emailPromoterAgency"],
            idPromoterAgency: localStorage.getItem("aGencyID"),
            uniqueCodeUsed: localStorage.getItem("aGencyCcod"),
            idlanguage: localStorage.getItem("lanId"),
            useremail: t("UserEmail", { returnObjects: true }),
            agencypromoteremail: t("AgencyPromoterEmail", {
              returnObjects: true,
            }),

            HeaderTag1: getCaertificateTag("h2_brandPromotor_tr_cert", "certificatetagTag1"),
            HeaderTag2: getCaertificateTag("h2_brandPromotor_tr_cert", "certificatetagTag2"),
            NameTag: getCaertificateTag("plain_text_NAME_CV", "value"),
            DateTag: getCaertificateTag("plain_text_DATE_CV", "value"),
            CertifiacteNoTag: getCaertificateTag("plain_text_CSN_CV", "value"),
            AgencyNameTag: getCaertificateTag("plain_text_BPA_CV", "value"),
            EmailFooterDes: getFooterTag("rich_text_footer_PH1", "value"),
          };

          localStorage.setItem("payloadsubmit", Base64.encode(JSON.stringify(payload)));
          localStorage.setItem("idTraineData", res.data.data.idTraineData);
          
          if (res.data.values === "TRAINING_INCOMPLETE") {
            localStorage.setItem("PID", Base64.encode(fingerprint + "P3"));
            history("/");
            window.location.reload();
          } else if (res.data.values === "QUIZZ_INCOMPLETE") {
            localStorage.setItem("PID", Base64.encode(fingerprint + "P4"));
            history("/");
            window.location.reload();
          } else if (res.data.values === "SURVEY_INCOMPLETE") {
            localStorage.setItem("PID", Base64.encode(fingerprint + "P5"));
            history("/");
            window.location.reload();
          } else {
            localStorage.setItem("PID", Base64.encode(fingerprint + "P1"));
            history("/");
            window.location.reload();
          }
        }
      } catch (error) {
        setbtnDisable(false);
        setIsloader(false);
        setsubmitted(false);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "customEvent",
          eventCategory: "Button",
          eventAction: "Button/Page View",
          eventLabel: "GOAL",
          eventValue: "Error",
        });
        if (error.response) {
          // handle error.response.data.msg if needed
        }
      }
    }
  };

  useEffect(() => {
    if (browserName === "Safari" || isIOS) {
      const strongs = document.querySelectorAll("strong");
      if (strongs.length) {
        strongs.forEach((strong) => {
          strong.setAttribute("style", "font-family:urw_geometricbold");
        });
      }
    }
  }, []);

  useEffect(() => {
    var currenttime = new Date();
    const mDsT = localStorage.getItem("mDsT");
    if (mDsT) {
      try {
        const decoded = Base64.decode(mDsT);
        if (decoded) {
          var startedtime = new Date(decoded);
          var checkseconds = (currenttime.getTime() - startedtime.getTime()) / 1000;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "customEvent",
            eventCategory: "Button",
            eventAction: "Traniee Details Page",
            eventLabel: "Training Completed",
            eventValue: checkseconds + " seconds",
          });
        }
      } catch (e) {
        console.error("Error decoding mDsT", e);
      }
      localStorage.removeItem("mDsT");
    }

    window.scrollTo(0, 0);
  }, []);

  // helper to map your options into objects that Multiselect expects (displayValue="value")
  const multiselectOptions =
    (getdata("brandMultiselectDropdown", "input_multiselect_dropdown", "options", "formContent") || []).map((opt) => ({
      value: opt.value,
    })) || [];

  // onSelect / onRemove centralized to keep other input in sync
  const handleSelect = (selectedList) => {
    setSelectedBrands(selectedList);
    setValue("brandMultiselectDropdown", selectedList.map((i) => i.value));
    clearErrors("brandMultiselectDropdown");
    // update button enablement after selection change
    setbtnDisable(!canEnableSubmit(fullnamerequired, emailaddressrequired, selectedList, otherBrandValue));
  };

  const handleRemove = (selectedList) => {
    setSelectedBrands(selectedList);
    setValue("brandMultiselectDropdown", selectedList.map((i) => i.value));

    // if "other" was removed, clear otherBrandValue and its form value
    const stillHasOther = selectedList.some((b) => isOtherOption(b.value));
    if (!stillHasOther) {
      setOtherBrandValue("");
      setValue("brandOther", "");
    }
    // determine effective other value after removal
    const effectiveOther = stillHasOther ? otherBrandValue : "";
    // update button enablement after removal change
    setbtnDisable(!canEnableSubmit(fullnamerequired, emailaddressrequired, selectedList, effectiveOther));
  };

  // central helper to decide if submit button can be enabled
  const canEnableSubmit = (
    fullOk = fullnamerequired,
    emailOk = emailaddressrequired,
    brands = selectedBrands,
    otherVal = otherBrandValue
  ) => {
    if (!fullOk || !emailOk) return false;
    // require at least one selected brand
    if (!brands || brands.length === 0) return false;
    const hasOther = (brands || []).some((b) => isOtherOption(b.value));
    if (hasOther) {
      return otherVal && String(otherVal).trim() !== "";
    }
    return true;
  };

  const brandsPlaceholder = selectedBrands?.length === 0 ? getdata("brandMultiselectDropdown", "input_multiselect_dropdown", "placeholder", "formContent") : ``;
  return (
    <>
      <section className="header2 theme-space px-lg-5 autofocus">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-10">
              <div className="text-wrapper">
                {Object.values(t("topContent", { returnObjects: true })).map((item) =>
                  item.fieldType === "h1" && item.value !== "" ? (
                    <h1 key={item.id} className="mb-5">
                      <ReactMarkdown components={{ p: React.Fragment, h1: React.Fragment, h2: React.Fragment, h3: React.Fragment, h4: React.Fragment, h5: React.Fragment, h6: React.Fragment }}>{item.value}</ReactMarkdown>
                    </h1>
                  ) : (
                    ""
                  )
                )}
                {Object.values(t("topContent", { returnObjects: true })).map((item) =>
                  item.fieldType === "plain_text" && item.value !== "" ? (
                    <p key={item.id} className="col-12 col-md-8 pe-lg-5 me-lg-5 page3topplainteext">
                      <ReactMarkdown components={{ p: React.Fragment }}>{item.value}</ReactMarkdown>
                    </p>
                  ) : (
                    ""
                  )
                )}
              </div>
            </div>
            <div className="col-12 col-md-2 col-lg-2"> </div>
          </div>
        </div>
      </section>

      <section className="theme-space px-lg-5 mb-3">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-6 col-lg-5">
              <div className="text-wrapper">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <>
                    <div className="position-relative">
                      <label htmlFor="fullName">
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {getdata("fullName", "input_text", "title", "formContent")}
                        </ReactMarkdown>
                      </label>
                      <input
                        {...register("fullName", {
                          required: true,
                          minLength: 2,
                          // pattern: /^(?! )(?!.* $)(?!.* {2})[^<>~!#/?_$^%&+=\[\]*()]+$/gm,
                          pattern: /^(?! )(?!.* $)(?!.* {2})[\p{L}\s'\-.]+$/u,
                          onChange: (e) => {
                            const newFullOk = e.target.value !== "";
                            setFullnamerequired(newFullOk);
                            if (!newFullOk) {
                              clearErrors("fullName");
                              setbtnDisable(true);
                              return;
                            }
                            setbtnDisable(!canEnableSubmit(newFullOk, emailaddressrequired, selectedBrands, otherBrandValue));
                          },
                        })}
                        maxLength={30}
                        className="w-100 px-3 py-2 mb-4"
                        placeholder={getdata("fullName", "input_text", "placeholder", "formContent")}
                        autoComplete="off"
                        id="fullName"
                      />

                      {errors.fullName?.type === "pattern" && (
                        <span className="error">
                          {getdata("fullName", "input_text", "errorText", "formContent")}
                        </span>
                      )}

                      {errors.fullName?.type === "minLength" && (
                        <span className="error">
                          {getdata("fullName", "input_text", "errorText", "formContent")}
                        </span>
                      )}
                    </div>

                    <div className="position-relative">
                      <label htmlFor="emailAddress">
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {getdata("emailAddress", "input_email", "title", "formContent")}
                        </ReactMarkdown>
                      </label>
                      <input
                        {...register("emailAddress", {
                          required: true,
                          pattern: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                          onChange: (e) => {
                            const newEmailOk = e.target.value !== "";
                            setEmailaddressrequired(newEmailOk);
                            if (!newEmailOk) {
                              clearErrors("emailAddress");
                              setbtnDisable(true);
                              return;
                            }
                            setbtnDisable(!canEnableSubmit(fullnamerequired, newEmailOk, selectedBrands, otherBrandValue));
                          },
                        })}
                        maxLength={75}
                        className="w-100 px-3 py-2 mb-4"
                        placeholder={getdata("emailAddress", "input_email", "placeholder", "formContent")}
                        autoComplete="off"
                        id="emailAddress"
                      />

                      {errors.emailAddress?.type === "pattern" && (
                        <span className="error">
                          {getdata("emailAddress", "input_email", "errorText", "formContent")}
                        </span>
                      )}
                    </div>

                    <div className="position-relative">
                      <label htmlFor="emailPromoterAgency">
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {getdata("emailPromoterAgency", "input_email", "title", "formContent")}
                        </ReactMarkdown>
                      </label>
                      <input
                        {...register("emailPromoterAgency", {
                          pattern: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                          onChange: (e) => {
                            e.target.value === "" || errors.emailPromoterAgency?.type === "pattern"
                              ? (e.target.className = "w-100 px-3 py-2 input3rd")
                              : (e.target.className = "w-100 px-3 py-2 input3rd");
                          },
                        })}
                        maxLength={75}
                        className="w-100 px-3 py-2 input3rd mb-4"
                        placeholder={getdata("emailPromoterAgency", "input_email", "placeholder", "formContent")}
                        disabled
                        autoComplete="off"
                        id="emailPromoterAgency"
                      />

                      {errors.emailPromoterAgency?.type === "pattern" && (
                        <span className="error error3rd">
                          {getdata("emailPromoterAgency", "input_email", "errorText", "formContent")}
                        </span>
                      )}
                    </div>

                    {/* Multi-select dropdown (from JSON: input_multiselect_dropdown) */}
                    <div className="position-relative mb-4">
                      <label htmlFor="brandMultiselectDropdown">
                        <ReactMarkdown components={{ p: React.Fragment }}>
                          {getdata("brandMultiselectDropdown", "input_multiselect_dropdown", "title", "formContent")}
                        </ReactMarkdown>
                      </label>

                      <Multiselect
                        id="brandMultiselectDropdown"
                        showSearch={false}
                        options={multiselectOptions}
                        displayValue="value"
                        selectedValues={selectedBrands}
                        onSelect={handleSelect}
                        onRemove={handleRemove}
                        className="w-100"
                        placeholder={brandsPlaceholder}
                        aria-label={getdata(
                          "brandMultiselectDropdown",
                          "input_multiselect_dropdown",
                          "alternateText",
                          "formContent"
                        )}
                        style={{
                          chips: {
                            background: "#562274",
                            borderRadius: "0px",
                          },
                          multiselectContainer: {
                          },
                          inputField: {},
                          searchBox: {
                            border: "1px solid transparent",
                          },
                        }}
                      />

                      {/* show "Other" input when 'other' is selected */}
                      {selectedBrands.some((b) => isOtherOption(b.value)) && (
                        <div className="position-relative mt-3">
                          <label htmlFor="brandOther">
                            <ReactMarkdown components={{ p: React.Fragment }}>
                              {getdata("brandOther", "input_brandOther", "title", "formContent") || "Other"}
                            </ReactMarkdown>
                          </label>
                          <input
                            id="brandOther"
                            className="w-100 px-3 py-2 mb-4"
                            value={otherBrandValue}
                            onChange={(e) => {
                              const v = e.target.value;
                              setOtherBrandValue(v);
                              // keep RHF in sync
                              setValue("brandOther", v);
                              // update button enablement when 'Other' changes
                              setbtnDisable(!canEnableSubmit(fullnamerequired, emailaddressrequired, selectedBrands, v));
                            }}
                            placeholder={getdata("brandOther", "input_brandOther", "placeholder", "formContent")}
                            maxLength={75}
                          />
                        </div>
                      )}

                      {errors.brandMultiselectDropdown?.type === "required" && (
                        <span className="error">
                          {getdata(
                            "brandMultiselectDropdown",
                            "input_multiselect_dropdown",
                            "errorText",
                            "formContent"
                          )}
                        </span>
                      )}
                    </div>
                  </>

                  {Object.values(t("formContent", { returnObjects: true })).map((item) =>
                    item.fieldType === "button" && item.value !== "" ? (
                      <button
                        aria-label={item.value}
                        ref={(ref) => (submitbutton.current = ref)}
                        disabled={btnDisable}
                        key={item.id}
                        className="faq-button"
                      >
                        <ReactMarkdown components={{ p: React.Fragment }}>{item.value}</ReactMarkdown>{" "}
                        {isloader ? <img alt="loader" className="loaderbtnimg" width={25} height={25} src={loadericon} /> : ""}
                      </button>
                    ) : (
                      ""
                    )
                  )}
                  <br />
                </form>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-7 image-wrapper"> </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Traineedetails;
